import React from 'react';
import strings from 'helper/localization/localization';

const Loading = () => (
  <div className="loading--container">
    <div className="loading--spinner" />
    <p>{strings.loading}</p>
  </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/modules/Loading.jsx